import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { api } from "./api";

const FIELD = "w-full rounded-xl bg-white border border-border px-4 py-2.5 outline-none focus:ring-2 focus:ring-coral focus:border-transparent";

export default function Templates() {
  const [templates, setTemplates] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = useCallback(async () => {
    const { data } = await api().get("/admin/templates");
    setTemplates(data);
  }, []);
  useEffect(() => { load(); }, [load]);

  const save = async () => {
    await api().put(`/admin/templates/${editing.key}`, editing);
    toast.success("Template saved.");
    setEditing(null); load();
  };

  return (
    <div className="space-y-5" data-testid="admin-templates-page">
      <p className="text-charcoal/60 text-sm">Merge fields available: {"{first_name} {community} {personalization_note} {upcoming_opportunity} {owner_name} {owner_email} {owner_phone} {owner_website}"}</p>
      <div className="grid md:grid-cols-2 gap-4">
        {templates.map(t => (
          <div key={t.key} data-testid={`tmpl-${t.key}`} className="rounded-2xl bg-white border border-border p-5">
            <div className="flex items-center justify-between mb-2">
              <h3 className="font-poppins font-bold">{t.name}</h3>
              <button onClick={() => setEditing({ ...t })} data-testid={`tmpl-edit-${t.key}`} className="text-sm rounded-full bg-cream border border-border px-3 py-1 font-semibold">Edit</button>
            </div>
            <p className="text-xs text-charcoal/60 mb-1">Subject: {t.subject}</p>
            <pre className="text-xs whitespace-pre-wrap text-charcoal/70 max-h-40 overflow-y-auto">{t.body.slice(0, 400)}{t.body.length > 400 ? "…" : ""}</pre>
          </div>
        ))}
      </div>

      {editing && (
        <div className="fixed inset-0 z-50 grid place-items-center p-4 bg-plum/40 backdrop-blur-sm" onClick={() => setEditing(null)}>
          <div className="w-full max-w-3xl rounded-2xl bg-white p-6 space-y-3" onClick={(e) => e.stopPropagation()}>
            <input className={FIELD} data-testid="tmpl-name" value={editing.name} onChange={(e) => setEditing({ ...editing, name: e.target.value })} />
            <input className={FIELD} data-testid="tmpl-subject" value={editing.subject} onChange={(e) => setEditing({ ...editing, subject: e.target.value })} />
            <textarea rows={14} className={FIELD} data-testid="tmpl-body" value={editing.body} onChange={(e) => setEditing({ ...editing, body: e.target.value })} />
            <div className="flex gap-2 justify-end">
              <button onClick={() => setEditing(null)} className="rounded-full bg-cream px-4 py-2 font-semibold">Cancel</button>
              <button onClick={save} data-testid="tmpl-save" className="rounded-full bg-coral text-cream px-4 py-2 font-semibold">Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
